import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcForwardReportData, RpcForwardResponse, RpcForwardUpKey } from './rpc-forward-model';

export class RpcForwardUpClient {
    /**
     * The forward up client call.
     *
     * @param data the forward report data object.
     * @return Promise<RpcForwardResponse> the promise object with forward response.
     */
    public static forward<T>(rpc: Rpc, data: RpcForwardReportData): Promise<RpcForwardResponse<T>> {
        return RpcInboundClient.call(rpc, RpcForwardUpKey.command, RpcForwardUpKey.version, data);
    }
}
